import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Row, Col, Collapse, Alert, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink, NavDropdown, UncontrolledDropdown, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, ButtonDropdown, Button, Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import rtlDetect from 'rtl-detect';
// if(typeof window !== 'undefined') {
//     var browserUpdate = require('browser-update'); // eslint-disable-line
// }

import { Helmet } from 'react-helmet';
import config from '../../../../config';
import { capitalizeFirstLetter } from '../../../../util/text';
import { enabledLanguages } from '../../../../../Intl/setup';

import { getUserPreference } from '../../../User/UserActions';
import { logoutUserRequest } from '../../../User/AuthActions';
import { setEmbeddedMode, isEmbedded } from '../../AppActions';
import { initLanguage, getCountryFromLanguage } from '../../../Intl/IntlActions';

import withRouter from '../../../../components/Router/WithRouter';
import Flag from '../../../../components/Flag/Flag';
import SearchMini from '../../../Search/components/SearchMini/SearchMini';
import CreditCheckAlert from '../../../Institution/components/credit/CreditCheckAlert';
import NotificationSummary from '../../../Notification/components/list/NotificationSummary';
import EnvironmentChecker from '../EnvironmentChecker';
import ShortcutAccess from '../shortcut/ShortcutAccess';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            dropdownLanguageOpen: false,
            dropdownNotificationsOpen: false,
            dropdownProfileOpen: false,
        };
    }

    componentDidMount() {
        this.switchLanguage(this.props.search.locale || getUserPreference(this.props.user, 'language'));
        if(this.props.search.embedded) {
            this.props.dispatch(setEmbeddedMode(this.props.search.embedded));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Update app language from user preferences
        if(!prevProps.user && this.props.user && !this.props.search.locale) {
            this.switchLanguage(getUserPreference(this.props.user, 'language'));
        }
    }

    isLoggedIn() {
        return this.props.user && this.props.user._id;
    }

    switchLanguage = lang => {
        lang !== this.props.intl.locale && this.props.dispatch(initLanguage(lang, this.props.user)).then(lang => {});
    };

    handleLogout() {
        // socket.emit('userDisconnection');
        this.props.dispatch(logoutUserRequest());
        this.props.navigate('/');
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    toggleDropdownLanguage = () => {
        this.setState({
            dropdownLanguageOpen: !this.state.dropdownLanguageOpen,
        });
    };

    toggleDropdownNotifications = () => {
        this.setState({
            dropdownNotificationsOpen: !this.state.dropdownNotificationsOpen,
        });
    };

    renderLanguages() {
        const languageNodes = enabledLanguages.filter(locale => locale !== this.props.intl.locale).map(
            lang => <DropdownItem key={lang} size="sm" onClick={event => this.switchLanguage(lang)}><span className={lang === this.props.intl.locale ? 'selected' : ''}><Flag country={getCountryFromLanguage(lang)} title={this.props.intl.formatMessage({ id: `appLocaleSwitch${lang.toUpperCase()}`, defaultMessage: `Switch to ${lang.toUpperCase()} locale` })} /></span></DropdownItem>,
        );
        return (
            <ButtonDropdown isOpen={this.state.dropdownLanguageOpen} toggle={() => this.toggleDropdownLanguage()}>
                <DropdownToggle nav caret>
                    <Flag country={getCountryFromLanguage(this.props.intl.locale)} />
                </DropdownToggle>
                <DropdownMenu className="text-center">{languageNodes}</DropdownMenu>
            </ButtonDropdown>
        );
    }

    render() {
        const locale = this.props.intl.locale.includes('-') ? this.props.intl.locale.split('-').shift() : this.props.intl.locale;
        return (
            <header>
                <Helmet
                    htmlAttributes={{
                        lang: locale,
                        // lang: `${intl.locale.split('-').shift()}-${intl.locale.split('-').length > 1 ? intl.locale.split('-').pop() : getCountryFromLanguage(intl.locale.split('-').shift())}`,
                        dir: rtlDetect.getLangDir(locale),
                    }}
                />
                {
                    this.isLoggedIn()
                    ? (
                        <Fragment>
                            <div className="header-wrapper">
                                {!this.props.isEmbedded && (
                                    <Navbar color="white" light expand className="navbar-expand-sm shadow static-top topbar">
                                        {['root', 'admin', 'manager', 'professor'].includes(this.props.user.role) && <SearchMini />}
                                        {/* <Alert color="info" className="mb-0 p-2 small">
                                            <FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage id="appUpdateClosingWarningAlert" defaultMessage="The application will be closed for maintenance from {start} to {end} (included)." values={{ start: moment.utc('2025-08-11T07:00:00').format('LLLL'), end: moment.utc('2025-08-12T23:59:59').format('LLLL') }} />
                                        </Alert> */}

                                        <Nav className="ms-auto" aria-label="Menu secondaire">
                                            <NavItem className="d-none d-sm-block">
                                                <ShortcutAccess />
                                            </NavItem>
                                            <NavItem className="d-none d-sm-block">
                                                <NavLink tag="span"><EnvironmentChecker /></NavLink>
                                            </NavItem>
                                            {['root', 'admin'].includes(this.props.user.role) && <NavItem className="d-none d-sm-block"><NavLink href={`${config.url}apidocs`} target="_blank"><FontAwesomeIcon icon="plug" /> API docs</NavLink></NavItem>}
                                            <NavItem>
                                                {this.renderLanguages()}
                                            </NavItem>
                                            {this.props.user.role !== 'student' && (
                                                <NavItem>
                                                    <NotificationSummary />
                                                </NavItem>
                                            )}
                                            <NavItem>
                                                <Dropdown isOpen={this.state.dropdownProfileOpen} toggle={() => this.setState({ dropdownProfileOpen: !this.state.dropdownProfileOpen })}>
                                                    <DropdownToggle caret nav className="text-secondary">
                                                        <FontAwesomeIcon icon="user-circle" /> <span className="ms-1 d-none d-lg-inline">{this.props.user ? `${this.props.user.firstName} ${this.props.user.lastName}` : null} </span>
                                                    </DropdownToggle>
                                                    <DropdownMenu className="text-center text-info">
                                                        <h6 className="dropdown-header">
                                                            <FormattedMessage id={`userRole${capitalizeFirstLetter(this.props.user.role)}`} defaultMessage={capitalizeFirstLetter(this.props.user.role)} />
                                                        </h6>
                                                        <DropdownItem tag={Link} to="/user/profile" className="d-block"><span className="d-none d-md-inline"><FontAwesomeIcon icon="user-circle" /> <FormattedMessage id="userAccountMy" defaultMessage="My account" /></span></DropdownItem>
                                                        <div className="dropdown-divider" />
                                                        <DropdownItem onClick={() => this.handleLogout()} className="text-danger"><FontAwesomeIcon icon="power-off" /> <span className="d-none d-xl-inline"><FormattedMessage id="userLogout" defaultMessage="Log out" /></span></DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </NavItem>
                                        </Nav>
                                    </Navbar>
                                )}

                                {['root', 'admin', 'manager'].includes(this.props.user.role) && !this.props.user.institutions.includes('*') && <CreditCheckAlert />}
                            </div>
                            {this.props.user && ((this.props.search.email && this.props.search.email !== this.props.user.email) || (this.props.search.accountcheck && this.props.search.accountcheck !== this.props.user._id.slice(-10))) && (
                                <Alert color="danger" className="text-center">
                                    <strong><FontAwesomeIcon icon="exclamation-circle" /> <FormattedMessage id="userAccountMismatchError" defaultMessage="You are logged with another account, please check your convocation email!" /></strong>
                                </Alert>
                            )}
                        </Fragment>
                    ) : (
                        <Row>
                            <Col xs="12" md={{ size: 8, offset: 2 }} className="px-3 py-3 text-end">
                                {this.renderLanguages()}
                            </Col>
                        </Row>
                    )
                }
            </header>
        );
    }
}
// <FormattedMessage id="accountMy" defaultMessage="My account" /> ({`${this.props.user.firstName} ${this.props.user.lastName}`})

function mapStateToProps(store, props) {
    return {
        user: store.users.user,
        isEmbedded: isEmbedded(store),
    };
}

Header.defaultProps = {
    user: null,
    isEmbedded: false,
};

Header.propTypes = {
    dispatch: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
    user: PropTypes.object,
    isEmbedded: PropTypes.bool,
};

export default connect(mapStateToProps)(withRouter(withIntl(Header)));
